const appConfig = {
  // backend url (with slash at end)
  URL: 'https://multihome.hu/',
  CONTACTEMAIL: 'info@multihome.hu',
  DEFAULTLANG: 'hu',
  LIMIT_ITEMS: 50,
};

export default appConfig;
